import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Emisor } from 'src/app/api/interfaces/domiciliacion';
import { DomiciliacionService } from 'src/app/api/services/domiciliacion/domiciliacion.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-emisor-dialog',
  templateUrl: './emisor-dialog.component.html',
  styleUrls: ['./emisor-dialog.component.scss']
})
export class EmisorDialogComponent implements OnInit {

  emisores: Emisor[] = [];

  form = new FormGroup({
    emisor: new FormControl(),
  });


  constructor(
    private domiciliacionService: DomiciliacionService,
    private dialogRef: MatDialog,
  ) { }

  ngOnInit(): void {
    this.domiciliacionService.getEmisores().subscribe( response => {
      this.emisores = response;
    },
    error => {
      console.error(error);
    });
  }

  onSubmit() {
    sessionStorage.setItem('emisor',JSON.stringify(this.form.value.emisor));
    this.dialogRef.closeAll();
  }

}
